import script from "./StickyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyHeader.vue?vue&type=script&setup=true&lang=js"

import "./StickyHeader.vue?vue&type=style&index=0&id=87a9db78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87a9db78"]])

export default __exports__